import { Action, createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import * as CourseActions from './course.actions';
import { CourseState, initialState } from './course.state';

const CourseReducer = createReducer(
  initialState,
  on(CourseActions.UpdateStateReducer, (state, value) => cloneDeep({ ...state, ...value })),
  on(CourseActions.SelectTypeReducer, (state, { type_active }) => cloneDeep({ ...state, type_active })),
);

export function reducer(state: CourseState, action: Action) {
  return CourseReducer(state, action);
}
